<template>
  <div class="research_group_container">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">课题组订单</span>
    </div>
    <div class="box">
      <div class="bd">
        <div class="group">
          <span class="allOrders" @click="changeTab(1)" :lines="undefined" :class="[tabIndex===1? 'colorBlack': 'colorGrey']">全部订单</span>
          <span class="pendingApproval" @click="changeTab(2)" :lines="undefined" :class="[tabIndex===2?'colorBlack': 'colorGrey']">待审批</span>
          <span class="execution" @click="changeTab(3)" :lines="undefined" :class="[tabIndex===3?'colorBlack': 'colorGrey']">执行中</span>
          <span class="completed" @click="changeTab(4)" :lines="undefined" :class="[tabIndex===4?'colorBlack': 'colorGrey']">已完成</span>
        </div>
        <div class="div" :style="{'margin-left': tabMarginLeft+'vw'}"/>
      </div>
      <div class="row" />
      <div class="submain">
        <div class="container_2" @click="changeOpenAll">
          <span class="filterItems" :lines="undefined">筛选项目</span>
          <svg v-show="!openAll" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>编组 4</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="待审批-未筛选" transform="translate(-334.000000, -173.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="编组-4" transform="translate(334.000000, 173.000000)">
                  <g id="展-开">
                    <path d="M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z" id="形状#merge#"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <svg v-show="openAll" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>编组 4</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="待审批-筛选展开" transform="translate(-210.000000, -350.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="编组-3" transform="translate(10.000000, 158.000000)">
                  <g id="编组-7" transform="translate(139.000000, 190.000000)">
                    <g id="编组-4" transform="translate(69.000000, 10.000000) scale(1, -1) translate(-69.000000, -10.000000) translate(61.000000, 2.000000)">
                      <g id="展-开">
                        <path d="M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z" id="形状"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="empty" />
        <div class="block_31" v-if="isDefaultStatus==2">
          <div class="tagWrap">
            <span class="tag" :lines="undefined">{{memberList[m_row][m_column].memberName}}</span>
          </div>
          <div class="container_31" @click="toDefineStatus">
            <span class="text_3" :lines="undefined">清除筛选</span>
            <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>清除</title>
              <desc>Created with Sketch.</desc>
              <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="待审批-筛选收起" transform="translate(-338.000000, -220.000000)" fill="#5878FA" fill-rule="nonzero">
                  <g id="编组-6" transform="translate(10.000000, 158.000000)">
                    <g id="编组-3" transform="translate(278.000000, 59.000000)">
                      <g id="清除" transform="translate(50.000000, 3.000000)">
                        <path d="M11.7067367,4.09942408 L9.53993109,3.04085548 L10.7536165,0.728290231 L10.7536165,0.728290217 C10.9207018,0.566034847 10.9246191,0.299050293 10.7623683,0.131961454 C10.76061,0.130150744 10.7588355,0.128355865 10.757045,0.126577031 L10.757045,0.126577026 C10.5812143,-0.0385082467 10.3086159,-0.0425930572 10.1279171,0.117148493 L8.78566331,2.67314166 L6.91713635,1.76457266 L6.91713643,1.7645727 C6.74439277,1.67484575 6.55370713,1.62505031 6.35914971,1.6188588 C6.05058563,1.6188588 5.84916185,1.77314411 5.76173536,1.92057228 L5.74630715,1.94971506 C4.37148273,4.85970728 0.408148492,6.46341728 0.367006614,6.47970295 L0.367006634,6.47970294 C0.203142231,6.54367737 0.0768666645,6.67814304 0.0233005287,6.84570196 C-0.0572689822,7.11227268 0.0944416927,7.35055776 0.126155224,7.39598621 L0.174154081,7.46627173 L7.41255323,11.7759745 C7.6671186,11.9259741 7.88397058,11.9996882 8.07596601,11.9996882 L8.07596599,11.9996882 C8.20082141,12.0039084 8.3233476,11.9651832 8.42310058,11.8899742 L8.44367152,11.8728314 C11.0604664,9.47626636 11.9038749,5.95256149 11.9861586,5.13999224 C12.0564427,4.44313696 11.8430192,4.19028049 11.7067367,4.09942359 L11.7067367,4.09942408 Z M11.1881776,5.06370721 C11.1881776,5.0697072 11.1067509,5.65684848 10.8247577,6.53970327 C9.5176459,5.92256206 6.53143126,4.26656649 5.5517403,3.7197108 L5.5517403,3.71971055 C5.88511828,3.31265584 6.17336857,2.87064452 6.41143299,2.4014297 C6.44400364,2.41000111 6.49285962,2.42542964 6.55800093,2.45714384 C6.97199108,2.65771473 10.0842027,4.17313925 11.0304659,4.63428087 L11.1864622,4.70970924 C11.1967477,4.7679948 11.2070331,4.8777088 11.1881764,5.0637083 L11.1881776,5.06370721 Z M7.54283576,8.989411 L7.54283576,8.989411 C7.71362009,8.83036053 7.72313415,8.56297285 7.56408704,8.39218492 C7.56050267,8.38833596 7.55684674,8.38455425 7.55312118,8.38084177 L7.55312118,8.38084177 C7.37729054,8.2157565 7.10469212,8.21167169 6.92399329,8.37141324 L5.53374067,9.67340976 L5.53374063,9.67340979 C5.51818533,9.68792078 5.50385143,9.70368828 5.49088464,9.72055239 L3.37464929,8.46055576 L4.79747257,7.52284398 L4.79747258,7.52284398 C4.99365987,7.39645297 5.05024335,7.13494769 4.92385515,6.93875625 C4.92095434,6.93425336 4.91796819,6.92980602 4.9148983,6.92541667 L4.91489829,6.92541665 C4.77097672,6.73123681 4.50121483,6.68177846 4.29777012,6.8122741 L2.69752249,7.86655699 L2.69752249,7.86655699 C2.64989528,7.89812227 2.60908995,7.93892845 2.57752535,7.98655667 L1.00984837,7.05227346 C1.80011528,6.6982744 3.58464424,5.79484825 5.02032435,4.31799505 C6.03087173,4.88285069 9.20993892,6.64941739 10.5659066,7.27855857 C10.1399168,8.37398421 9.35479262,9.92540863 8.00825324,11.2034052 L8.00825324,11.2034052 C7.94770263,11.1786987 7.88923094,11.1491757 7.83340026,11.11512 L6.26572329,10.1834082 L7.54283575,8.98941141 L7.54283576,8.989411 Z" id="形状"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div class="submain1" v-show="isDefaultStatus==1">
          <span class="info_2" :lines="undefined">课题组成员</span>
          <div class="grid" v-show="!open">
            <div class="col1" @click="chooseMember(0,-1)" :class="[(m_row===0&&m_column===-1)?'choose-col': 'nochoose-col']">
              <span :class="[(m_row===0&&m_column===-1)?'tag': 'tag_2']" :lines="undefined">全部成员</span>
            </div>
            <div class="col2" v-for="(member,i) in memberList[0]" @click="chooseMember(0,i)" :class="[(m_row===0&&m_column===i)?'choose-col': 'nochoose-col']">
              <span :class="[(m_row===0&&m_column===i)?'tag': 'tag_2']" :lines="undefined">{{member.memberName}}</span>
            </div>
          </div>
          <div v-show="open" style="margin-left:3.53vw">
            <div class="grid" v-for="(innerList,index) in memberList" v-if="innerList.length>0">
              <div v-show="index===0" class="col1" @click="chooseMember(0,-1)" :class="[(m_row===0&&m_column===-1)?'choose-col': 'nochoose-col']">
                <span :class="[(m_row===0&&m_column===-1)?'tag': 'tag_2']" :lines="undefined">全部成员</span>
              </div>
              <div v-for="(member,i) in innerList" class="col1" @click="chooseMember(index,i)" :class="[(m_row===index&&m_column===i)?'choose-col': 'nochoose-col']">
                <span :class="[(m_row===index&&m_column===i)?'tag': 'tag_2']" :lines="undefined">{{member.memberName}}</span>
              </div>
            </div>
          </div>

          <div class="group_2" v-show="!open" @click="changeOpen">
            <span class="clickExpand" :lines="undefined">点击展开</span>
            <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>编组 4</title>
              <desc>Created with Sketch.</desc>
              <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="待审批-未筛选" transform="translate(-334.000000, -173.000000)" fill="#5878FA" fill-rule="nonzero">
                  <g id="编组-4" transform="translate(334.000000, 173.000000)">
                    <g id="展-开">
                      <path d="M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z" id="形状#merge#"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="group_2" v-show="open" @click="changeOpen">
            <span class="clickExpand" :lines="undefined">点击收起</span>
            <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>编组 4</title>
              <desc>Created with Sketch.</desc>
              <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="待审批-筛选展开" transform="translate(-210.000000, -350.000000)" fill="#5878FA" fill-rule="nonzero">
                  <g id="编组-3" transform="translate(10.000000, 158.000000)">
                    <g id="编组-7" transform="translate(139.000000, 190.000000)">
                      <g id="编组-4" transform="translate(69.000000, 10.000000) scale(1, -1) translate(-69.000000, -10.000000) translate(61.000000, 2.000000)">
                        <g id="展-开">
                          <path d="M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z" id="形状"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <order-info-list :orderStatus="tabIndex" :orderListOrigin="orderList" :chooseMemberName="chooseMemberName" :chooseStatus="chooseStatus"></order-info-list>
    </div>
  </div>
</template>

<script>
  import orderInfoList from './OrderInfoList'
  import {mapGetters, mapState} from 'vuex'
  import EMKT from '../../../../emkt'
  export default {
    name: 'ResearchGroupOrder',
    components: {
      orderInfoList
    },
    data () {
      return {
        isDefaultStatus: 1,
        open: false,
        openAll: false,
        tabIndex: 1,
        m_column: -1,
        m_row: 0,
        orderList: {},
        chooseMemberName: '全部成员',
        chooseStatus: 1,
        isWapp: EMKT.isWapp
      }
    },
    mounted () {
      this.fetchOrderData()
    },
    activated () {
      console.log('researchGroupOrder activated')
      this.fetchOrderData()
    },
    computed: {
      tabMarginLeft: function () {
        return (this.tabIndex - 1) * 22.8 + 6
      },
      ...mapState([
        'researchGroupMemberMap'
      ]),
      ...mapGetters([
        'displayChosenResearchGroup'
      ]),
      memberList () {
        if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return [[]]
        if (!this.researchGroupMemberMap || JSON.stringify(this.researchGroupMemberMap) === '{}') return [[]]
        const researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
        var totalMemberList = this.researchGroupMemberMap[researchGroupNo]
        var doubleList = [[]]
        var num = 0 // 已经循环的成员总数
        for (var i = 0; i <= (totalMemberList.length + 1) / 3; i++) {
          doubleList[i] = []
          let k = 0 // 每行的成员总数
          for (var j = num; j < totalMemberList.length; j++) {
            if ((i === 0 && k < 2) || (i !== 0 && k < 3)) {
              doubleList[i][k] = totalMemberList[j]
              num++
              k++
            } else {
              break
            }
          }
        }
        console.log('课题组成员二维数组', doubleList)
        // return this.researchGroupMemberMap[researchGroupNo]
        return doubleList
      }
    },
    methods: {
      fetchOrderData: function () {
        if (this.$route.query.tabIndex) {
          this.tabIndex = this.$route.query.tabIndex - 0
        } else {
          this.tabIndex = 1
        }
        this.orderList = EMKT.getLocalStorage('ResearchGroupOrderList')
        console.log('researchGroupOrderList', this.orderList)
      },
      goBack: function () {
        this.$router.push({name: 'ResearchGroupHome'})
      },
      changeOpenAll: function () {
        this.openAll = !this.openAll
        this.open = this.openAll
        if (this.openAll) {
          this.isDefaultStatus = 1
          this.chooseStatus = 1
        } else {
          if (this.m_row === 0 && this.m_column === -1) {
            // 显示选中全部成员的布局
            this.isDefaultStatus = 1
            this.chooseStatus = 1
          } else {
            // 显示选中单个成员的布局
            this.isDefaultStatus = 2
            this.chooseStatus = 2
          }
        }
      },
      changeOpen: function () {
        this.open = !this.open
        this.openAll = this.open
        if (!this.open) {
          if (this.m_row === 0 && this.m_column === -1) {
            // 显示选中全部成员的布局
            this.isDefaultStatus = 1
            this.chooseStatus = 1
          } else {
            // 显示选中单个成员的布局
            this.isDefaultStatus = 2
            this.chooseStatus = 2
          }
        }
      },
      changeTab: function (index) {
        this.tabIndex = index
      },
      chooseMember: function (mrow, mcolumn) {
        this.openAll = true
        this.m_column = mcolumn
        this.m_row = mrow
        if (mcolumn !== -1) {
          this.chooseMemberName = this.memberList[this.m_row][this.m_column].memberName
          this.chooseStatus = 2
        } else {
          this.chooseStatus = 1
        }
      },
      toDefineStatus: function () {
        this.isDefaultStatus = 1
        this.open = false
        this.openAll = false
        this.memberNo = 0
        this.m_column = -1
        this.m_row = 0
        this.chooseMemberName = '全部成员'
        this.chooseStatus = 1
      }
    }
  }
</script>

<style scoped>
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100%;
  }

  .navshare {
    position: absolute;
    left: 6.67vw;
    width: 10vw;
    height: 10vw;
    padding-top: 2vw;
    color:#ffffff;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    max-width: 60.53vw;
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
  }


  .box {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #efeef3;
    width: 100vw;
    height: 97vh;
    top: 14.93vw;
    bottom: 4vw;
  }

  .hd {
    display: flex;
    flex-shrink: 0;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
  }

  .bd {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 2.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 94.67vw;
    height: 13.33vw;
  }

  .group {
    display: flex;
    flex-shrink: 0;
    position: relative;
    flex-shrink: 0;
    align-items: center;
    align-self: center;
    flex-direction: row;
    margin-top: 4vw;
    width: 80.27vw;
    height: 5.33vw;
  }

  .allOrders {
    opacity: 1;
    margin-right: 9.33vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.73vw;
    font-weight: 400;
  }
  .colorGrey {
    color: #979797!important;
    font-weight: 400!important;
  }
  .colorBlack {
    color: #424242!important;
    font-weight: bold!important;
  }
  .pendingApproval {
    opacity: 1;
    margin-right: 11.2vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: bold;
  }

  .execution {
    opacity: 1;
    margin-right: 11.2vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .completed {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .div {
    position: relative;
    margin-top: 3.6vw;
    margin-left: 28.53vw;
    border-top-width: 2px;
    border-top-style: solid;
    border-top-color: rgba(88, 120, 250, 1);
    width: 15.47vw;
    height: 0.8vw;
  }

  .row {
    position: relative;
    margin-top: 2.13vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.67vw;
    height: 0.27vw;
  }

  .submain {
    display: flex;
    flex-shrink: 0;
    flex-shrink: 0;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 0.27vw;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.67vw;
    border-color: rgba(239, 238, 243, 1);
    background-color: #ffffff;
    width: 94.67vw;
  }
  .submain1 {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 0.27vw;
    border-color: rgba(239, 238, 243, 1);
    background-color: #ffffff;
    width: 93.67vw;
    border-radius: 2.67vw;
  }
  .container_2 {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 3.2vw;
    width: 86.4vw;
    height: 5.33vw;
  }

  .filterItems {
    opacity: 1;
    max-width: 79.2vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 4.27vw;
    font-weight: bold;
  }


  .empty {
    position: relative;
    margin-top: 2.4vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .info_2 {
    position: relative;
    opacity: 1;
    margin-top: 3.73vw;
    margin-left: 3.73vw;
    max-width: 87.47vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: bold;
  }

  .grid {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    margin-top: 2.4vw;
    width: 86.67vw;
    height: 6.13vw;
  }
  .col1 {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 2.93vw;
    border-radius: 2.93vw;
    width: 26.93vw;
    height: 6.13vw;
  }

  .tag {
    opacity: 1;
    max-width: 23.73vw;
    height: 5.33vw;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .col2 {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 2.93vw;
    border-radius: 2.93vw;
    background-color: #efeef3;
    width: 26.93vw;
    height: 6.13vw;
  }
  .choose-col {
    border-width: 1px!important;
    border-style: solid!important;
    border-color: rgba(88, 120, 250, 1)!important;
    background-color: rgba(88, 120, 250, 0.15)!important;
  }
  .nochoose-col {
    background-color: #efeef3!important;
  }
  .tag_2 {
    opacity: 1;
    max-width: 23.73vw;
    height: 5.33vw;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .col3 {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-radius: 2.93vw;
    background-color: #efeef3;
    width: 26.93vw;
    height: 6.13vw;
  }

  .tag_3 {
    opacity: 1;
    max-width: 23.73vw;
    height: 5.33vw;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .tagWrap {
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    flex-direction: row;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    border-color: rgba(88, 120, 250, 1);
    background-color: rgba(88, 120, 250, 0.15);
    padding-right: 3.73vw;
    padding-left: 3.47vw;
    height: 6.13vw;
    margin-left: 3vw;
  }

  .tag {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .container_31 {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    flex-direction: row;
    height: 5.33vw;
    margin-right: -3vw;
  }

  .text_3 {
    opacity: 1;
    margin-right: 0.53vw;
    max-width: 36.8vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .group_2 {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    margin-top: 4vw;
    margin-bottom: 4vw;
    width: 20.27vw;
    height: 5.33vw;
  }

  .clickExpand {
    opacity: 1;
    margin-right: 1.33vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.73vw;
    font-weight: 400;
  }


  .block_31 {
    display: flex;
    flex-shrink: 0;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 3.47vw;
    width: 86.67vw;
    height: 6.13vw;
    margin-bottom: 4vw;
  }


  .ft {
    position: relative;
    margin-top: 48.53vw;
    border-radius: 0.53vw;
    background-color: #000000;
    width: 35.73vw;
    height: 1.33vw;
  }
</style>



// WEBPACK FOOTER //
// ResearchGroupOrder.vue?0b6c7896